export const getStablePdfUrl = (pdfFile) => {
  if (!pdfFile) return null;

  const isS3Url = pdfFile.includes("amazonaws.com");
  return isS3Url
    ? pdfFile
    : pdfFile.startsWith("data:application/pdf")
    ? pdfFile
    : `${pdfFile}`;
};
